import { render, staticRenderFns } from "./today-attendances.vue?vue&type=template&id=c06e399c"
import script from "./today-attendances.vue?vue&type=script&lang=js"
export * from "./today-attendances.vue?vue&type=script&lang=js"
import style0 from "./today-attendances.vue?vue&type=style&index=0&id=c06e399c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports